export type UserDocumentVersionJSON = {
  id: number;
  document_id?: number;
  document_type_id?: number;
  update_by_user_id?: number;
  title?: string;
  s3_key?: string;
  s3_version?: string;
  thumbnail_s3_key?: string;
  processing_complete?: boolean;
  advisor_access?: boolean;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string;
};

export class UserDocumentVersion {
  static path = "versions";
  constructor(
    public id?: number,
    public documentId?: number,
    public documentTypeId?: number,
    public updateByUserId?: number,
    public title?: string,
    public s3Key?: string,
    public s3Version?: string,
    public thumbnailS3Key?: string,
    public processingComplete?: boolean,
    public advisorAccess?: boolean,
    public createdAt?: string,
    public updatedAt?: string,
    public deletedAt?: string
  ) {}

  static fromJSON = (json?: UserDocumentVersionJSON): UserDocumentVersion => {
    return json
      ? new UserDocumentVersion(
          json.id,
          json.document_id,
          json.document_type_id,
          json.update_by_user_id,
          json.title,
          json.s3_key,
          json.s3_version,
          json.thumbnail_s3_key,
          json.processing_complete !== null
            ? json.processing_complete
            : undefined,
          json.advisor_access !== null ? json.processing_complete : undefined,
          json.created_at,
          json.updated_at,
          json.deleted_at
        )
      : new UserDocumentVersion();
  };

  get ext(): string | undefined {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [fileName, fileExt] = this?.s3Key?.split(".") || [];
    return fileExt;
  }

  get name(): string | undefined {
    const [fileName] = this?.s3Key?.split(".") || [];
    return fileName;
  }
}
